<template>
  <ExtracadabraModal
    v-model:opened="opened"
    :header="{ title: modalTitle, bgColor: 'primary', textColor: 'white' }"
    :card="{ class: 'recruitment-recap-modal' }"
  >
    <template #body>
      <RecruitmentRecap
        :precision="recruitment.getPrecisions()"
        :address="recruitment.getCurrentEtablissement().getFormattedAddress()"
        :open-to-novice="recruitment.isNovicesAllowed()"
        :qualification="recruitment.getQualificationLabel()"
      />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import {
    ACTION_DASHBOARD_CLOSE_RECRUITMENT_RECAP_MODAL,
    GETTER_DASHBOARD_RECRUITMENT_RECAP,
    GETTER_DASHBOARD_RECRUITMENT_RECAP_MODAL_OPENED,
  } from "@etab/stores/types";
  import { useDashboardStore } from "@etab/stores/dashboard";
  import { mapStores } from "pinia";
  import { ExtracadabraModal } from "@core/components/modals";
  import RecruitmentRecap from "./RecruitmentRecap.component.vue";

  export default {
    components: {
      RecruitmentRecap,
      ExtracadabraModal,
    },
    computed: {
      ...mapStores(useDashboardStore),
      opened: {
        get() {
          return this.dashboardStore[GETTER_DASHBOARD_RECRUITMENT_RECAP_MODAL_OPENED];
        },
        set(value) {
          if (value === false) {
            this.dashboardStore[ACTION_DASHBOARD_CLOSE_RECRUITMENT_RECAP_MODAL]();
          }
        },
      },
      recruitment() {
        return this.dashboardStore[GETTER_DASHBOARD_RECRUITMENT_RECAP];
      },
      modalTitle() {
        if (this.recruitment.isSeason()) {
          const type = this.$t("ETAB.PAGES.RECRUITMENT.TYPES.@SEASON");
          return this.$t("ETAB.PAGES.RECRUITMENT.RECAP_MODAL.@TITLE", { type });
        }
        if (this.recruitment.isCDI()) {
          const type = this.$t("ETAB.PAGES.RECRUITMENT.TYPES.@CDI");
          return this.$t("ETAB.PAGES.RECRUITMENT.RECAP_MODAL.@TITLE", { type });
        }
        // else
        return this.$t("ETAB.PAGES.RECRUITMENT.RECAP_MODAL.@TITLE_AE");
      },
    },
  };
</script>

<style lang="scss">
  .recruitment-recap-modal {
    $modal-header-height: 50px;
    position: relative;

    .recruitment-recap-modal-header {
      background-color: $primary;
      color: white;
      box-shadow: $layout-shadow;
      height: $modal-header-height;
    }

    .recruitment-recap-modal-content {
      height: calc(100% - #{$modal-header-height});
      margin-top: $modal-header-height;
    }
  }
</style>
